import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { ClipLoader } from "react-spinners";
import oet_service from "../redux/service";
import swal from "sweetalert";
import { utils } from "~/utils";

const titles = [
    "Item",
    "Item Code",
    "Item Description",
    "VOA Item",
    "Order Qty",
    "Price per Unit",
    "Total Unit Price",
    "Delivery Date"
];

class ScratchPOModal extends React.Component {
    selectRef = React.createRef();

    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            data: null,
            isLoading: false,
            isSending: false
        };
    }

    onSave = () => {
        const currency = this.selectRef.current.value;
        this.setState({ isSending: true });
        oet_service
            .send_confirmation_info_scratch_po(this.props.runID, currency)
            .then((data) => {
                this.setState({ isSending: false, modal: false, data: null });
                swal({
                    title: "Successfully!",
                    text: data.detail,
                    icon: "success",
                    timer: 3000,
                    button: true
                });
            })
            .catch((error) => {
                swal({
                    // title: "Validation",
                    text: utils.computeError(error),
                    icon: "warning",
                    timer: 6000,
                    button: true
                });
                this.setState({ isSending: false });
            });
    };

    toggle = () => {
        this.setState(
            {
                modal: !this.state.modal
            },
            () => {
                if (this.state.modal) {
                    this.charge_scratch_po_data();
                } else {
                    this.setState({ data: null });
                }
            }
        );
    };

    charge_scratch_po_data = () => {
        console.log("charge_scratch_po_data");
        this.setState({ isLoading: true });
        oet_service.get_confirmation_info_scratch_po(this.props.runID).then(data => {
            this.setState({ data, isLoading: false });
        });
    };

    computeRows = items => {
        if (items) {
            if (items.length !== 0) {
                return items.map((row, index) => {
                    return (
                        <tr key={`scratch_po_${index}`}>
                            <td className="text-center">{row && row.item}</td>
                            <td className="text-center">{row && row.item_code}</td>
                            <td className="text-center">{row && row.item_description}</td>
                            <td className="text-center">{row && row.voa_item}</td>
                            <td className="text-center">{row && row.order_quantity}</td>
                            <td className="text-center">$ {row && row.price_per_unit}</td>
                            <td className="text-center">$ {row && row.total_price}</td>
                            <td className="text-center">{row && row.delivery_date}</td>
                        </tr>
                    );
                });
            }
        }
        return (
            <tr>
                <td colSpan={titles.length}>No data found</td>
            </tr>
        );
    };

    render() {
        const { className, button } = this.props;
        const { modal, data } = this.state;
        const modalStyle = { width: "80%", maxWidth: "80%" };
        console.log("data", data);
        return (
            <React.Fragment>
                {button && (
                    <Button color="primary" onClick={this.toggle}>
                        Create Scratch PO
                    </Button>
                )}
                <Modal isOpen={modal} toggle={this.toggle} className={className} backdrop="static" style={modalStyle}>
                    <ModalHeader toggle={this.toggle}>Create Scratch PO</ModalHeader>
                    <ModalBody>
                        <table className="table table-sm table-bordered">
                            <colgroup>
                                <col style={{ width: "250px" }} />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" className="w-150 p-1">
                                        OET Name
                                    </th>
                                    <td className="p-1">{data && data.oet_name}</td>
                                </tr>
                                <tr>
                                    <th scope="col" className="w-150 p-1">
                                        Project Name
                                    </th>
                                    <td className="p-1">{data && data.project_name}</td>
                                </tr>
                                <tr>
                                    <th scope="col" className="w-150 p-1">
                                        Non Sode ID
                                    </th>
                                    <td className="p-1">{data && data.non_sode_id}</td>
                                </tr>
                                <tr>
                                    <th scope="col" className="w-150 p-1">
                                        Vendor
                                    </th>
                                    <td className="p-1">{data && data.vendor}</td>
                                </tr>
                                <tr>
                                    <th scope="col" className="w-150 p-1">
                                        SVO Number
                                    </th>
                                    <td className="p-1">{data && data.svo_number}</td>
                                </tr>
                                <tr>
                                    <th scope="col" className="w-150 p-1">
                                        SPO Header Text
                                    </th>
                                    <td className="p-1">{data && data.spo_header_text}</td>
                                </tr>
                                <tr>
                                    <th scope="col" className="w-150 p-1">
                                        SVO Text
                                    </th>
                                    <td className="p-1">{data && data.svo_text}</td>
                                </tr>
                                <tr>
                                    <th scope="col" className="w-150 p-1">
                                        SVO number
                                    </th>
                                    <td className="p-1">{data && data.svo_number}</td>
                                </tr>
                                <tr>
                                    <th scope="col" className="w-150 p-1">
                                        Contract or WBS
                                    </th>
                                    <td className="p-1">{data && data.contract_or_wbs}</td>
                                </tr>
                                <tr>
                                    <th scope="col" className="w-150 p-1">
                                        Contract item
                                    </th>
                                    <td className="p-1">{data && data.contract_item}</td>
                                </tr>
                                <tr>
                                    <th scope="col" className="w-150 p-1">
                                        VOA number
                                    </th>
                                    <td className="p-1">{data && data.voa_number}</td>
                                </tr>
                                <tr>
                                    <th scope="col" className="w-150 p-1">
                                        Circle & JD Code
                                    </th>
                                    <td className="p-1">{data && data.circle_and_jd_code}</td>
                                </tr>
                                <tr>
                                    <th scope="col" className="w-150 p-1">
                                        Currency
                                    </th>
                                    <td className="p-1">
                                        <select ref={this.selectRef}>
                                            {data &&
                                                data.currency_choices.map(cr => {
                                                    const isDefault = cr.code === data.currency.code;
                                                    const ops = {
                                                        ...(isDefault ? { selected: "selected" } : {}),
                                                        value: cr.id
                                                    };
                                                    return <option {...ops}>{cr.code}</option>;
                                                })}
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="col" className="w-150 p-1">
                                        PO Total Value
                                    </th>
                                    <td className="p-1">{data && data.po_total_value}</td>
                                </tr>
                            </thead>
                        </table>
                        <div className="table-content tableFixHead" style={{ overflowY: "auto", maxHeight: "200px" }}>
                            <table className="table table-bordered table-striped ">
                                <thead className="thead-dark">
                                    <tr>
                                        {titles &&
                                            titles.map((title, index) => (
                                                <th key={`cpo_title_${index}`} scope="col">
                                                    {title}
                                                </th>
                                            ))}
                                    </tr>
                                </thead>
                                <tbody>{this.computeRows(data ? data.ssot_items : [])}</tbody>
                            </table>
                        </div>
                        {this.state.isLoading && (
                            <div className="float-right" style={{
                                position: "absolute",
                                top: 0,
                                bottom: 0,
                                right: 0,
                                left: 0,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                background: "white"
                            }}>
                                <ClipLoader />
                            </div>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <span>Are you sure you want to submit this job to SAP?</span>
                        {this.state.isSending && (
                            <div className="float-right">
                                <ClipLoader />
                            </div>
                        )}
                        <Button disabled={this.state.isSending} icon="save" color="primary" onClick={this.onSave}>
                            Yes
                        </Button>
                        or
                        <Button disabled={this.state.isLoading} color="danger" onClick={this.toggle}>
                            No
                        </Button>
                    </ModalFooter>
                </Modal>
            </React.Fragment>
        );
    }
}

export default ScratchPOModal;
